import { FaChevronDown } from "react-icons/fa";

import { Select } from "radix-ui";

import type { PermissionValue } from "entities/permissions";

import Eye from "shared/assets/svgs/eye.svg?react";
import Lock from "shared/assets/svgs/lock.svg?react";
import UserPen from "shared/assets/svgs/user-pen.svg?react";
import { cn } from "shared/utils/cn";

type Props = {
  value?: PermissionValue;
  placeholder?: string;
  onValueChanged: (value: PermissionValue) => void;
};

export const SelectPermission = (props: Props) => {
  const { value, placeholder = "Select access", onValueChanged } = props;
  return (
    <Select.Root value={value} onValueChange={onValueChanged}>
      <Select.Trigger
        className={cn(
          "flex h-7.5 w-36 max-w-40.5 items-center rounded-full border px-2.5 py-2 text-sm leading-5.5 font-medium tracking-[0.4px] outline-hidden",
          !value && "border-pale-grey text-pale-grey",
          value === "No Access" && "border-pale-grey text-dawn-pink",
          value === "Full Access" && "border-pale-green/30 text-pale-green",
          value === "Read Only" && "border-butter/30 text-butter"
        )}
      >
        {value && (
          <span className="mr-1.5 inline-flex">
            {value === "No Access" && <Lock className="size-4.5" />}
            {value === "Full Access" && <UserPen className="size-4.5" />}
            {value === "Read Only" && <Eye className="size-4.5" />}
          </span>
        )}

        <Select.Value placeholder={placeholder}>{value}</Select.Value>
        <Select.Icon className="ml-auto">
          <FaChevronDown className="text-pale-grey size-3.5" />
        </Select.Icon>
      </Select.Trigger>

      <Select.Portal>
        <Select.Content
          className="border-dark-grey bg-oil rounded-xl border"
          position="popper"
        >
          <Select.Viewport>
            <SelectItem value="No Access" className="text-dawn-pink">
              <Lock className="size-4.5" /> No Access
            </SelectItem>
            <SelectItem value="Full Access" className="text-pale-green">
              <UserPen className="size-4.5" /> Full Access
            </SelectItem>
            <SelectItem value="Read Only" className="text-butter">
              <Eye className="size-4.5" /> Read Only
            </SelectItem>
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

const SelectItem = ({ className, ...props }: Select.SelectItemProps) => {
  return (
    <Select.Item
      className={cn(
        "flex cursor-pointer items-center gap-x-1.5 px-2 py-2 outline-hidden select-none hover:brightness-125",
        className
      )}
      {...props}
    />
  );
};
